<!-- 用户首次登录填写信息页面 -->
<template>
  <div class="info">

    <div class="masking" v-if="submited">
      <div class="mask_box">
        <div class="title">初次登录信息补充</div>
        <div class="mask_con">
          <img src="../assets/images/login_icon6.png" alt="">
        </div>
        <div class="tips">
          <p>您的资料已提交审核，近期会有短信反馈，请及时查收。</p>
          <p>10月9日培训项目正式启动，可登录平台学习。</p>
        </div>
        <div class="btn" @click="toIndex"><<回首页</div>
      </div>
    </div>

    <div class="header">
      <div class="container" @click="toLogin">
        <img class="logo" src="../assets/images/login_icon1.png" alt="">
        <div class="con">
          <p class="big">国培计划(2021)</p>
          <p class="small">中小学教师网络法治教育培训项目</p>
        </div>
        <!-- <div class="btn" @click="toLogin">登录</div> -->
      </div>
    </div>
    <div class="content">
      <div class="top">
        <img src="../assets/images/login_icon2.png" alt="">
        <span>初次登录信息补充</span>
      </div>
      <div class="form">
      <el-form :model="form" ref="form" class="demo-form-inline" :rules="rules">

        <el-row type="flex">
          <el-col :span="8">
              <el-form-item label="姓名" label-width="1.55rem" prop="name">
                <el-input v-model="form.name" disabled></el-input>
              </el-form-item>
              <el-form-item label="民族" label-width="1.55rem" prop="nation">
                <el-input v-model="form.nation"></el-input>
              </el-form-item>
              <el-form-item label="工作单位" label-width="1.55rem" prop="company">
                <el-input v-model="form.company"></el-input>
              </el-form-item>

              <el-form-item label="身份证号" label-width="1.55rem" prop="idcard">
                <el-input v-model="form.idcard" disabled></el-input>
              </el-form-item>
              <el-form-item label="传真" label-width="1.55rem">
                <el-input v-model="form.fax"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="8">
              <el-form-item label="性别" label-width="1.55rem" prop="gender">
                <div class="gender" @click="changeGender(0);">
                  <img v-if="gender == 1" src="../assets/images/login_icon3.png" alt="">
                  <img v-if="gender == 0" src="../assets/images/login_icon4.png" alt="">
                  <span>男</span>
                </div>
                <div class="gender" @click="changeGender(1);">
                  <img v-if="gender == 0" src="../assets/images/login_icon3.png" alt="">
                  <img v-if="gender == 1" src="../assets/images/login_icon4.png" alt="">
                  <span>女</span>
                </div>
              </el-form-item>
              <el-form-item label="出生年月" required label-width="1.55rem">
                 <el-form-item prop="date">
                <el-date-picker type="date" v-model="form.date"></el-date-picker>
                 </el-form-item>
              </el-form-item>
              <el-form-item label="职务/职称" label-width="1.55rem" prop="professional">
                <el-input v-model="form.professional"></el-input>
              </el-form-item>
              <el-form-item label="手机号" label-width="1.55rem" prop="mobile">
                <el-input v-model="form.mobile" disabled></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" required label-width="1.55rem">
                <el-input v-model="form.email"></el-input>
              </el-form-item>
            <!-- </el-form> -->
          </el-col>
          <el-col :span="8">
            <div class="up_head">
              <div class="">
                <span class="label">头像</span>
                <!-- <span class="symbol">*</span> -->
                <img class="head" :src="avatar" alt="" v-if="avatar">
                <img class="head" src="../assets/images/head.png" alt="" v-if="!avatar">
              </div>
              <div class="up_btn">
                <img src="../assets/images/login_up.png" alt="">
                <!-- <span>上传文件</span> -->
                <span>
                  <el-upload
                    class="upload-file"
                    accept=".jpg,.gif,.bmp"
                    :action="doUpload"
                    :headers="Headers"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                    :show-file-list="false"
                    ref="newupload"
                    multiple
                    :auto-upload="false">
                    <div class="type2">
                      上传文件
                    </div>
                  </el-upload>
                </span>
              </div>
              <p>支持jpg、gif或bmp格式的图片</p>
              <p>建议文件小于20M</p>

            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="19">
            <el-form-item label="课程组别" label-width="1.55rem" prop="session">
              <div class="gender" @click="changeSession(10);">
                <img v-if="session != 10" src="../assets/images/login_icon3.png" alt="">
                <img v-if="session == 10" src="../assets/images/login_icon4.png" alt="">
                <span>2021中小学教师网络法治教育培训项目（小学组)</span>
              </div>
              <div class="gender" @click="changeSession(11);">
                <img v-if="session != 11" src="../assets/images/login_icon3.png" alt="">
                <img v-if="session == 11" src="../assets/images/login_icon4.png" alt="">
                <span>2021中小学教师网络法治教育培训项目（中学组)</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
              <el-row>
                <el-col :span="19">
                  <el-form-item label="所在地区" label-width="1.55rem" prop="areaId">
                    <div class="distance">
                      <v-distpicker @selected="sel" :province="form.province" :city="form.city" :area="form.area"></v-distpicker>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="16">
                 <el-form-item label="通讯地址" required prop="address" label-width="1.55rem">
                   <el-input v-model="form.address"></el-input>
                 </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="邮编" label-width="0.72rem">
                    <el-input v-model="form.postCode"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="7">
                 <el-form-item label="最高学历" label-width="1.55rem" prop="education">
                   <el-input v-model="form.education"></el-input>
                 </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="学位" label-width="0.69rem" prop="degree">
                    <el-input v-model="form.degree"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="毕业学校" label-width="0.97rem" prop="school">
                    <el-input v-model="form.school"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                <el-form-item label="个人简介" label-width="1.55rem">
                  <el-input type="textarea" v-model="info" rows="4" resize="none" style="background-color: #f1f1f1;border: none;"></el-input>
                </el-form-item>
                </el-col>
              </el-row>
               <el-row>
                <el-col :span="22">
                  <span style="float: left;font-size: 0.16rem;line-height: 0.24rem;width: 1.15rem;margin-left: 0.4rem;padding-right: 0.13rem;color: #333;">*近三年参加相关培训情况</span>
                  <el-form-item label=" " label-width="1.2rem" style="padding-left: 0.35rem;line-height: 0.22rem;">
                    <el-input type="textarea" v-model="peixunInfo" rows="4" resize="none" style="background-color: #f1f1f1;border: none;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
             <!-- <el-row>
                <el-col :span="22">
                  <span style="float: left;font-size: 0.16rem;line-height: 0.24rem;width: 1.25rem;margin-left: 0.3rem;padding-right: 0.13rem;color: #333;">*上传《学员信息表》盖章文件</span>
                <el-form-item label=" " v-model="proveUrl" label-width="1.55rem">
                  <div class="up_btn" style="">
                    <img src="../assets/images/login_up.png" alt="">
                  <span>上传文件</span>
                    <el-upload
                      class="upload-file"
                      accept="pdf"
                      :action="doUploadFile"
                      :headers="Headers"
                      :on-change="handleFileChange"
                      :before-upload="beforeFileUpload"
                      :on-success="handleFileSuccess"
                      :show-file-list="false"
                      ref="newuploadFile"
                      multiple
                      :auto-upload="false">
                      <div class="type2">
                        上传文件
                      </div>
                    </el-upload>
                  </div>
                  <p style="font-size: 0.14rem;color: #999;line-height: 0.15rem;">支持扩展名：pdf</p>
                  <p style="font-size: 0.14rem;color: #999;line-height: 0.15rem;margin-top: 0.1rem;" v-if="fileurl">上传成功 <span style="margin-left: 0.2rem;">{{filename}}</span></p>
                </el-form-item>
                </el-col>
              </el-row>-->
              <el-form-item label=" " label-width="1.55rem">
                <el-button class="submit" type="danger" @click="onSubmit">提交</el-button>
              </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="footer">
      <div class="container">
        <p class="top">北京国语大学  外语教学与研究出版社 教育部全国青少年普法网运营中心</p>
        <p class="cen">         网站概况        机构职能        版权与免责声明 </p>
        <p class="bot">© 2020  外语教学与研究出版社  版权所有  |  京ICP备10028400号-3 </p>
      </div>
    </div> -->
  </div>

</template>

<script>
  import VDistpicker from 'v-distpicker'
export default {
  components: {
    VDistpicker
  },
  data(){
    return {
      event:'',
      avatar:'',
      fileurl:'',
      filename:'',
      form:{
        name: '',
        nation: '',
        company:'',
        idcard:'',
        fax:'',

        wxCard:'',

        date:'',
        professional:'',
        mobile:'',
        email:'',

        address:'',
        postCode:'',
        education:'',
        degree:'',
        school:'',
        session: 0,
        provinceId:'',
        cityId:'',
        areaId:'',
        proveUrl: '',
		  gender:0
      },
	  rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
		gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        nation: [{ required: true, message: '请输入民族', trigger: 'blur' }],
        company: [{required: true, message: '请输入工作单位', trigger: 'blur' }],
        idcard: [ {required: true, message: '请输入身份证号', trigger: 'blur' }],
        date: [{ required: true, message: '请选择出生年月', trigger: 'change' }],
		email:[{ required: true, message: '请输入邮箱', trigger: 'change' }],
        professional: [{required: true, message: '请输入职务/职称', trigger: 'blur' }],
        area: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
		 address:[{ required: true, message: '请输入通信地址', trigger: 'change' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        session: [{ required: true, message: '请选择培训项目组别', trigger: 'blur' }],
		peixunInfo: [{ required: true, message: '请输入近三年的相关培训情况', trigger: 'blur' }],
        proveUrl: [{ required: true, message: '请上传《学员信息表》', trigger: 'blur' }],
      },
      session: 0,
      gender:0,
      province:'',
      city:'',
      area:'',
      peixunInfo:'',
      info:'',
      uploaded:'',
      doUpload:'',
      doUploadFile:'',
      Headers:{},
      submited:false,
    }
  },
  mounted() {
   // this.$emit('footer',false);
   var _this = this;
   this.event = JSON.parse(localStorage.getItem('event'));
   this.doUpload = this.url_post+'/trainee/updatephoto'+'?access-token='+localStorage.getItem('token')+'&eventId='+this.event.eventId
   this.doUploadFile = this.url_post+'/reportFile/proveFileUpload'+'?access-token='+localStorage.getItem('token');
   this.getInfo();
  },
  methods:{
    getInfo(){
      var _this = this;
      var params = {};
      this.post('/trainee/info',params,(data)=>{
        if(data.status == 200){
          var res = data.data;
          _this.event.eventId = res.eventId;
          _this.info = res.info;
          _this.form.gender = res.gender;
          _this.form.company = res.schoolName;
          _this.form.wxCard = res.wxCard;
          _this.form.nation = res.mingzu;
          _this.form.professional = res.professional;
          _this.form.fax = res.fax;
          _this.form.email = res.email;
          _this.form.proveUrl = res.proveUrl
          _this.form.province = res.provinceId;
          _this.form.city = res.cityId;
          _this.form.area = res.districtId;
          _this.province = res.provinceId;
          _this.city = res.cityId;
          _this.area = res.districtId;

          _this.form.address = res.address;
          _this.form.postCode = res.postCode;
          _this.form.education = res.education;
          _this.form.degree = res.degree;
          _this.form.school = res.school;
          _this.peixunInfo = res.peixunInfo;
          _this.avatar = res.photoUrl;

          _this.form.mobile = res.mobile;
          _this.form.name = res.name;
          _this.form.idcard = res.idCard;
          _this.form.date = res.birthDate;
        }
      })
    },
    changeGender(index){
      this.gender = index;
	  this.form.gender = index;
    },
    changeSession(index){
      this.session = index;
	  this.form.session = index;
    },
    sel(data) {
      console.log(data);
      this.form.provinceId = data.province.code;
      this.form.cityId = data.city.code;
      this.form.areaId = data.area.code;

      this.province = data.province.value;
      this.city = data.city.value;
      this.area = data.area.value;
    },
    onSubmit() {

	var _this = this;
      if(_this.session==0){
        _this.$mResToast({
          type:'error',
          msg:'请选择培训项目组别',
          duration:3000,
          isIcon:true,
        });
        return false;
      }
      var _this = this;
    /*  if(!_this.fileurl){
        _this.$mResToast({
          type:'error',
          msg:'请上传学员信息表',
          duration:3000,
          isIcon:true,
        });
        return false;
      }*/

      if(!_this.peixunInfo){
        _this.$mResToast({
          type:'error',
          msg:'请输入培训信息',
          duration:3000,
          isIcon:true,
        });
        return false;
      }

      this.$refs['form'].validate((valid) => {
        if (valid) {
          // console.log(valid);
          var birthDate = _this.form.date;
          if(birthDate.length == 10){
            console.log(birthDate);
          }else{
            birthDate = (parseInt(_this.form.date/1000)).c_time('yyyy-MM-dd')
          }
          console.log(typeof(birthDate));
          console.log(birthDate);
          var params = {
            "eventId":_this.event.eventId,
            "info":_this.info,
            "gender":_this.form.gender == 0 ? '男' : '女',
            "schoolName":_this.form.company,
            "wxCard":_this.form.wxCard,
            "mingzu":_this.form.nation,
            "birthDate":birthDate,
            "professional":_this.form.professional,
            "fax":_this.form.fax,
            "email":_this.form.email,
            "provinceId":_this.province,
            "cityId":_this.city ,
            "districtId":_this.area,
            "address":_this.form.address,
            "postCode":_this.form.postCode,
            "education":_this.form.education,
            "degree":_this.form.degree,
            "school":_this.form.school,
            "peixunInfo":_this.peixunInfo,
            "proveUrl":_this.form.proveUrl,
            "session" : _this.session
          }
          console.log(params);
          this.post('/trainee/updateTraneeInfo',params,(data)=>{
            console.log(data);
            if(data.status == 200){
              // _this.submited = true;
              localStorage.setItem('event',JSON.stringify(data.data));
              _this.$router.push('Course');
            }else{
              _this.$mResToast({
                type:data.status == 200 ? 'success' : 'error',
                msg:data.msg,
                duration:3000,
                isIcon:true,
              });
            }
            console.log(data);
          })
        } else {
          return false;
        }
      });
    },

    toLogin(){
       window.open("http://qspfw.moe.gov.cn/html/gpjh/");
    },
    toIndex(){
      this.$router.replace('/')
    },
    // 上传文件：学员信息表
    handleFileSuccess(e){
      var _this = this;
      console.log(e);
      if(e.status == 200&&e.data){
        _this.fileurl = e.data;
        _this.form.proveUrl=e.data;
      }
      _this.$mResToast({
        type:e.status == 200 ? 'success' : 'error',
        msg:e.msg,
        duration:3000,
        isIcon:true,
      });
    },
    beforeFileUpload(file){
      var _this = this;
      console.log(file);
      if(file.name){
        _this.filename = file.name;
      }
      let extension = file.name.substring(file.name.lastIndexOf('.')+1);
      console.log(extension);
      if(extension === 'pdf') {
        return true;
      }else{
        _this.$mResToast({
          type:'error',
          msg:'文件类型不正确',
          duration:3000,
          isIcon:true,
        });
        return false;
      }
    },
    handleFileChange(file) {
      this.$refs.newuploadFile.submit();
    },

    // 上传文件：用户头像
    handleChange(file) {
      this.$refs.newupload.submit();
    },
    handleSuccess(e){
      var _this = this;
      console.log(e);
      if(e&&e.data&&e.data.url){
        _this.avatar = e.data.url;
      }
      _this.$mResToast({
        type:e.status == 200 ? 'success' : 'error',
        msg:e.msg,
        duration:3000,
        isIcon:true,
      });
    },
    beforeUpload(file){
      var _this = this;
      console.log(file)
      let extension = file.name.substring(file.name.lastIndexOf('.')+1);
      console.log(extension);
      if(extension === 'jpg' || extension === 'gif' || extension === 'bmp') {
        return true;
      }else{
        _this.$mResToast({
          type:'error',
          msg:'文件类型不正确',
          duration:3000,
          isIcon:true,
        });
        return false;
      }
    },
  }
}
</script>

<style scoped>
.info{
  background-color: #e9e9e9;
  padding-bottom: 0.4rem;
}

.masking{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 20;
}
.masking .mask_box{
  width: 10.86rem;
  height: 4.31rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  z-index: 22;
  border-radius: 0.1rem;
}
.masking .mask_box .title{
  font-size: 0.18rem;
  color: #000;
  font-weight: 700;
  margin-top: 0.31rem;
  width: 10rem;
  margin-left: 0.55rem;
}

.masking .mask_box .mask_con{
  width: 0.94rem;
  height: 0.93rem;
  margin: 0.7rem auto 0.6rem auto;
}
.masking .mask_box .mask_con img{
  width: 100%;
  height: 100%;
}
.masking .mask_box .tips{
  width: 100%;
}
.masking .mask_box .tips p{
  font-size: 0.14rem;
  color: #666;
  line-height: 0.22rem;
  text-align: center;
}
.masking .mask_box .btn{
  width: 1.37rem;
  height: 0.36rem;
  margin: 0.4rem auto;
  background-color: #de0000;
  font-size: 0.16rem;
  color: #fff;
  border-radius: 0.05rem;
  text-align: center;
  line-height: 0.36rem;
  cursor: pointer;
  user-select: none;
}


.header{
  width: 100%;
  height: 1rem;
  background-color: #fff;
}
.header .container{
  width: 12rem;
  height: 1rem;
  margin: 0 auto;
}
.header .container .logo{
  width: 0.58rem;
  height: 0.58rem;
  float: left;
  margin: 0.26rem 0.14rem 0 0;
}
.header .container .con{
  width: 9rem;
  height: 1rem;
  float: left;
}
.header .container .big{
  font-size: 0.2rem;
  color: #de0000;
  font-weight: 700;
  margin-top: 0.36rem;
  line-height: 0.2rem;
}
.header .container .small{
  font-size: 0.16rem;
  color: #000;
  line-height: 0.16rem;
  margin-top: 0.05rem;
}
.header .container .btn{
  float: right;
  width: 0.8rem;
  height: 0.38rem;
  line-height: 0.38rem;
  background-color: #de0000;
  border-radius: 0.1rem;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  margin-top: 0.36rem;
  cursor: pointer;
  user-select: none;
}


.content{
  width: 12rem;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
  margin-top: 0.42rem;
  padding-bottom: 0.3rem;
}
.content .top{
  height: 0.64rem;
  width: 100%;
  background-color: #DE0000;
  display: flex;
  justify-content: center;
  align-items: center;

}
.content .top img{
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.27rem;
}
.content .top span{
  font-size: 0.24rem;
  color: #fff;
}

.content .form{
  width: 100%;
  margin-top: 0.8rem;
}


.content .form .up_head{
  width: 2.5rem;
  margin-left: 1rem;
}
.content .form .up_head .label{
  float: left;
  font-size: 0.16rem;
  color: #333;
}
.content .form .up_head .label .symbol{
  font-size: 0.16rem;
  color: #e60012;
}
.content .form .up_head .head{
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
}
.content .form .up_head .up_btn{
  margin-left: 0.4rem;
}
.content .form .up_head p{
  font-size: 0.14rem;
  color: #b5b5b5;
  margin-left: 0.4rem;
}




.content .form .gender{
  float: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 0.06rem;
  cursor: pointer;
  user-select: none;
}
.content .form .gender img{
  margin-right: 0.06rem;
}
.content .form .el-input__inner{
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}
.content .form .el-form-item__label{
  font-size: 0.16rem;
  color: #333;
}

.content .form .distance{
  width: 100%;
  height: 0.5rem;
}
.content .form .distance span{
  font-size: 0.25rem;
  line-height: 0.47rem;
  color: #7c7c7c;
  float: left;
  margin-right: 0.2rem;
}
.content .form .distance >>> .distpicker-address-wrapper{
  float: left;
}
.content .form .distance >>> .distpicker-address-wrapper select{
  text-align: right;
  font-size: 0.16rem;
  color: #333;
  outline: none;
  float: left;
  padding: 0;
  width: 2.07rem;
  height: 0.45rem;
  line-height: 0.45rem;
  border-radius: 4px;
  margin-right: 0.11rem;
  background-color: #f1f1f1;
}

.content .form >>> .el-textarea__inner{
  background-color: #f1f1f1;
  border: none;
  outline: none;
  border-radius: 4px;
}
.content .form >>> .el-input__inner{
  background-color: #f1f1f1;
  border: none;
  outline: none;
  border-radius: 4px;
}
.content .form .up_btn{
  width: 1.27rem;
  height: 0.38rem;
  background-image: linear-gradient(0deg,
    #f2f2f2 0%,
    #ffffff 100%),
  linear-gradient(
    #f1f1f1,
    #f1f1f1);
  background-blend-mode: normal,
    normal;
  border-radius: 0.02rem;
  border: solid 0.01rem #e4e4e4;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin-bottom: 0.1rem;
}
.content .form .up_btn span{
  font-size: 0.16rem;
  color: #333;
}
.content .form .up_btn img{
  margin-right: 0.09rem;
}
.content .form .submit{
  width: 1.03rem;
  height: 0.42rem;
  background-color: #de0000;
  border-radius: 0.08rem;
  margin-top: 0.1rem;
}

.footer{
  width: 100%;
  height: 1.3rem;
  background-color: #2b2b2b;
  margin-top: 0.42rem;
}
.footer .container{
  width: 12rem;
  height: 100%;
  margin: 0 auto;
}
.footer .container .top{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  padding-top: 0.45rem;
}
.footer .container .cen{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer .container .bot{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
   margin-top: 0.21rem;
}


</style>



// WEBPACK FOOTER //
// src/components/Info.vue